import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import LogoNavigation from '../components/commons/organisms/LogoNavigation';
import { PALE, SOFT_TOMATO } from '../components/colors';
import OrderSummary from '../components/checkout/organisms/OrderSummary';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../utils/api';
import Skeleton from 'react-loading-skeleton';
import usePageView from '../hooks/use-page-view';
import { MIXPANEL_ACTION, MIXPANEL_PAGE } from '../utils/constants';
import MixpanelService from '../utils/mixpanel';

interface OrderSuccessProps {};

const OrderSuccess = ({}: OrderSuccessProps) => {

  const navigate = useNavigate();
  const {
    order: orderNumber
  } = useParams();
  const [order, setOrder] = useState<any>();
  const [consumerDetails, setConsumerDetails] = useState<any>();

  usePageView(MIXPANEL_PAGE.ORDER_SUCCES);

  const fetchOrder = async () => {
    if (!orderNumber) return;
    const data = await APIService.getOrder(orderNumber);
    setConsumerDetails(data.customer || data.guest)
    setOrder(data);
  }

  useEffect(() => {
    fetchOrder();
  }, [])

  if (!order) {
    return (<>
      <LogoNavigation />
      <Layout>
        <OrderSummaryInfo>
          <StyledSkeleton height={100} baseColor={PALE} />
        </OrderSummaryInfo>
        <Root>
          <StyledSkeleton height={500}  />
        </Root>
      </Layout>
    </>)
  }

  return (
    <>
      <LogoNavigation />
      <Layout>
        <OrderSummaryInfo>
          <OrderSummary
            products={order.items}
            totalAmount={order.totalPrice}
            shippingAmount={0}
          />
        </OrderSummaryInfo>
        <Root>
          <Heading>
            <HeadingDetails>
              <p>
                <strong>{`THANK YOU, ${consumerDetails.firstName}`.toUpperCase()}</strong>
              </p>
              <OrderNumber>
                {`Order #: ${orderNumber}`.toUpperCase()}
              </OrderNumber>
              <OrderDate>
                <p>{moment(order.createdDate).format('MM-DD-YYYY')}</p>
              </OrderDate>
            </HeadingDetails>
          </Heading>
          <Content>
            <ContentLabel>
              <p>CONTACT INFORMATION</p>
            </ContentLabel>
            <ContentValue>
              <p>{consumerDetails.email.toUpperCase()}</p>
            </ContentValue>
            <ContentValue>
              <p>{consumerDetails.mobile.toUpperCase()}</p>
            </ContentValue>

            <ContentLabel>
              <p>DELIVERY</p>
            </ContentLabel>
            <ContentValue>
              <p>{order.address?.country?.toUpperCase() || ''}</p>
              <p>{order.address.street.toUpperCase()}</p>
              <p>{order.address.town.toUpperCase()}</p>
              <p>{order.address.province.toUpperCase()}</p>
              <p>{order.address.postCode.toUpperCase()}</p>
            </ContentValue>

            <button
              onClick={() => {
                MixpanelService.track(`${MIXPANEL_PAGE.ORDER_SUCCES} - ${MIXPANEL_ACTION.BUTTON_CLICK}`, {
                  item: 'Continue'
                });
                navigate('/');
              }}
            >
              CONTINUE SHOPPING
            </button>
            
            <ContentValue>
              <p>
                <strong>{`Note: Please disregard if you paid using EXPRESS CHECKOUT`.toUpperCase()}</strong>
                <br/>
                <br/>
              {`For Cash on Delivery: Our staff will contact you for order confirmation
              Connect with us via Facebook messager and Instagram to process your orders.`.toUpperCase()}
              </p>
            </ContentValue>
          </Content>
        </Root>
      </Layout>
    </>
  )
};

const StyledSkeleton = styled(Skeleton)`

`;

const Layout = styled.div`
  display: flex;
  flex-direction: column;

  @media(min-width: 768px) {
    max-width: 1200px; /* or 1280px */
    margin: 0 auto;
    padding: 1rem 1rem; /* optional side padding */
    flex-direction: row;
  }
`;

const OrderSummaryInfo = styled.div`
  flex: 1;
`;

const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1rem 1rem;

  @media(min-width: 768px) {
    padding-top: 0rem;
  }
`;

const Heading = styled.div`
  display: flex;
  flex-direction: row;
`;

const ImgCheckCircle = styled.div`
  height: 64px;

  img {
    width: 100%;
    height: inherit;
    object-fit: cover;
    fill: red;
  }
`;

const HeadingDetails = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  

  p {
    margin: 0 0;
    // font-family: 'Poppins-Light';
    // font-size: 0.8rem;
  }
`;

const OrderNumber = styled.p`
  font-family: 'Poppins-SemiBold';
  font-size: 1rem;
  margin: 0 0;
  color: ${SOFT_TOMATO};
`;
const OrderDate = styled.p`
  font-family: 'Poppins-Light';
  font-size: 0.8rem;
  margin: 0 0;
  color: ${SOFT_TOMATO};
`;

const Content = styled.div`
  padding: 1rem 0rem;
   button {
    margin: 1rem 0rem;
    width: 100%;
    border: none;
    background-color: ${SOFT_TOMATO};
    color: white;
    border-radius: 6px;
    height: 40px;
    font-family: 'Poppins-SemiBold';
    font-size: 0.8rem;
  };
`;

const ContentLabel = styled.div`
  p {
    margin: 0rem 0rem;
    font-family: 'Poppins-Medium';
    font-size: 1rem;
    margin-top: 0.5rem;
  }
`;

const ContentValue = styled.div`
  p {
    margin: 0 0;
    font-family: 'Poppins-Light';
    font-size: 0.8rem;
  }
`;

export default OrderSuccess;
